<template>
    <v-row class="wrapper">
        <v-col
            v-show="form.ID_SOL_PRORROGACAO"
            sm="12"
            md="8"
            offset-md="2"
        >
            <v-card>
                <v-card-title class="primary--text">
                    SOLICITAÇÃO DE PRORROGAÇÃO
                </v-card-title>
                <v-card-text>
                    <v-form
                        ref="form"
                        @submit.prevent="enviarSolicitacao"
                    >
                        <v-row>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.ID_SOL_PRORROGACAO"
                                    filled
                                    readonly
                                    label="ID"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.CREATED_AT ? new Date(form.CREATED_AT).toLocaleString() : ''"
                                    filled
                                    readonly
                                    label="CRIADA EM"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.UPDATED_AT ? new Date(form.UPDATED_AT).toLocaleString() : ''"
                                    filled
                                    readonly
                                    label="ATUALIZADA EM"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col
                                cols="4"
                                class="py-0"
                            >
                                <v-text-field
                                    :value="form.CNPJ"
                                    filled
                                    readonly
                                    label="CNPJ"
                                />
                            </v-col>
                            <v-col
                                class="py-0"
                            >
                                <v-text-field
                                    :value="form.RAZAO_SOCIAL"
                                    filled
                                    readonly
                                    label="RAZÃO SOCIAL"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col
                                cols="4"
                                class="py-0"
                            >
                                <v-text-field
                                    :value="form.NOTA_FISCAL"
                                    filled
                                    readonly
                                    label="NOTA FISCAL"
                                />
                            </v-col>
                            <v-col
                                cols="4"
                                class="py-0"
                            >
                                <v-text-field
                                    :value="form.NOTA_FISCAL_SERIE"
                                    filled
                                    readonly
                                    label="NOTA FISCAL - SÉRIE"
                                />
                            </v-col>
                            <v-col
                                cols="4"
                                class="py-0"
                            >
                                <v-text-field
                                    :value="form.DATA_VENCIMENTO_ORIGINAL"
                                    filled
                                    readonly
                                    label="DATA DE VENCIMENTO ORIGINAL"
                                />
                            </v-col>
                        </v-row>

                        <v-text-field
                            :value="form.CONTATO"
                            filled
                            readonly
                            label="CONTATO"
                        />

                        <v-row>
                            <v-col
                                cols="4"
                                class="py-0"
                            >
                                <v-text-field
                                    :value="form.TELEFONE"
                                    filled
                                    readonly
                                    label="TELEFONE"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.EMAIL"
                                    filled
                                    readonly
                                    label="E-MAIL"
                                />
                            </v-col>
                        </v-row>

                        <v-text-field
                            :value="form.NOME_MOTIVO_SOL_PRORROGACAO"
                            filled
                            readonly
                            label="MOTIVO"
                        />

                        <v-text-field
                            :value="form.JUSTIFICATIVA"
                            filled
                            readonly
                            label="JUSTIFICATIVA"
                        />

                        <v-select
                            v-model="form.ID_STATUS_SOLICITACAO"
                            :items="statusList"
                            item-value="ID_STATUS_SOLICITACAO"
                            item-text="NOME"
                            label="STATUS"
                            outlined
                        />

                        <v-textarea
                            v-model="form.OBSERVACAO"
                            outlined
                            label="OBSERVAÇÃO"
                            placeholder="digite uma observação para o atendimento"
                            rows="3"
                            maxlength="500"
                            counter
                        />

                        <v-layout justify-space-between>
                            <v-btn
                                large
                                text
                                color="primary"
                                @click="() => printDocument()"
                            >
                                <v-icon left>
                                    mdi-printer
                                </v-icon>
                                Imprimir
                            </v-btn>

                            <v-btn
                                large
                                color="primary"
                                @click="atualizarSolicitacao"
                            >
                                <v-icon left>
                                    mdi-check
                                </v-icon>
                                Atualizar Solicitação
                            </v-btn>
                        </v-layout>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import api from '../../../services/api';

    export default {
        data() {
            return {
                form: {
                    ID_SOL_PRORROGACAO: null,
                    CREATED_AT: null,
                    UPDATED_AT: null,
                    CNPJ: null,
                    RAZAO_SOCIAL: null,
                    NOTA_FISCAL: null,
                    NOTA_FISCAL_SERIE: null,
                    DATA_VENCIMENTO_ORIGINAL: null,
                    CONTATO: null,
                    TELEFONE: null,
                    EMAIL: null,
                    NOME_MOTIVO_SOL_PRORROGACAO: null,
                    JUSTIFICATIVA: null,
                    ID_STATUS_SOLICITACAO: null,
                    OBSERVACAO: null
                },

                statusList: []
            };
        },

        created() {
            this.fetchSolicitacao();
            this.fetchStatusList();
        },

        methods: {
            async fetchSolicitacao() {
                try {
                    const response = await api.getSolProrrogacaoByID(this.$route.params.id);

                    this.form = response.data;
                } catch (error) {
                    if (error.response && error.response.status === 404) {
                        this.$router.push('/painel-solprorrogacao');
                    }
                }
            },

            async fetchStatusList() {
                try {
                    const response = await api.getStatusSolicitacao();

                    this.statusList = response.data;
                } catch (error) {}
            },

            async atualizarSolicitacao() {
                try {
                    await api.updateSolProrrogacao(this.form.ID_SOL_PRORROGACAO, this.form);

                    await this.fetchSolicitacao();

                    this.$root.$emit('message', { text: 'Solicitação atualizada com sucesso!', color: 'success' });
                } catch (error) {
                    this.$root.$emit('message', { text: 'Erro ao atualizar a solicitação.', color: 'error' });
                }
            },

            printDocument() {
                window.print();
            }
        }
    };
</script>